exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sw-label[data-v-0d4d49ae]{color:#000;font-weight:500;display:block;font-size:1rem;margin-bottom:5px}", ""]);

// exports
